export const FEATURE_FLAG = 'move_your_stuff_mvp';
export const HOLDBACK_CONTROL = 'mys_hold_back_dolly_control';
